import { Access } from '@typings';
import { useTranslation } from 'react-i18next';

export const useRoleLabels = (): Record<Access, string> => {
  const { t } = useTranslation(['common']);

  return {
    buyer: t('common:role.buyer'),
    seller: t('common:role.seller'),
    viewer: t('common:role.viewer'),
  };
};
